import { render, staticRenderFns } from "./LateralContentFoto.vue?vue&type=template&id=bb26a462&scoped=true"
import script from "./LateralContentFoto.vue?vue&type=script&lang=js"
export * from "./LateralContentFoto.vue?vue&type=script&lang=js"
import style0 from "./LateralContentFoto.vue?vue&type=style&index=0&id=bb26a462&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb26a462",
  null
  
)

export default component.exports